import { Link } from 'react-router-dom';
import { Button } from '@immo/ui-kit';
import { useTranslations } from '@/i18n/use-translations';
import { ErrorWithId } from './error-with-id';
import { PageStateLandmark } from '@/components/layout/main-landmark';

type Props = {
  code?: string | undefined;
  id?: string | undefined;
  details?: Record<string, unknown> | undefined;
  onRetry?: () => void;
};

/**
 * Page-level reportable-error view, per ADR 0014. Delegates the message + id
 * to `<ErrorWithId>` and adds the page chrome: a retry affordance (when the
 * caller supplies one) and the back-to-home exit.
 */
export function ErrorPage({ code, id, details, onRetry }: Props) {
  const t = useTranslations('pages.error');

  return (
    <PageStateLandmark className="mx-auto flex max-w-3xl flex-col items-center justify-center gap-4 p-8">
      <h2 className="text-2xl font-semibold">{t('title')}</h2>
      <ErrorWithId code={code} id={id} details={details} />
      <div className="flex items-center gap-3">
        {onRetry !== undefined && <Button onClick={onRetry}>{t('try-again')}</Button>}
        <Button variant="secondary" asChild>
          <Link to="/">{t('home')}</Link>
        </Button>
      </div>
    </PageStateLandmark>
  );
}
